var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-container"},[_c('swiper-small',{attrs:{"list":_vm.bannerArr}}),_c('div',{staticStyle:{"margin":"10px 0"}},[_c('Grouplist',{attrs:{"list":_vm.goodsList}})],1),(!_vm.goodsList.length)?_c('div',{staticClass:"nodata"},[_vm._v("暂无活动")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }